import React from "react";

import { Container, Row, Col } from "reactstrap";

import RegisterCard from "views/pages/Register/RegisterCard";
import { MarketingBlurbs } from "views/pages/Register/MarketingBlurbs";

export default class Register extends React.Component {
  componentDidMount() {
    document.body.classList.toggle("register-page");
  }
  componentWillUnmount() {
    document.body.classList.toggle("register-page");
  }
  render() {
    return (
      <div className="register-page">
        <Container>
          <Row className={"d-flex flex-row-reverse"}>
            <Col className="mr-auto" lg="4" md="6">
              <RegisterCard />
            </Col>
            <Col className="ml-auto" sm="0" lg="5" md="5">
              <MarketingBlurbs />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
